export default {
  items: [
    {
      name: 'Membership',
      url: '/membership',
      icon: 'icon-organization'
    },
    {
      name: 'NewLetter',
      icon: 'icon-envelope-open',
      active: false,
      children: [
        {
          name: 'Listings',
          url: '/newsletter/listing',
        },
        {
          name: 'Campaigns',
          url: '/newsletter/campaigns',
        },
      ],
    },
    {
      divider: true
    },
    {
      name: 'People',
      url: '/people',
      icon: 'icon-people'
    },
    {
      name: 'Donations',
      url: '/donation',
      icon: 'icon-wallet'
    },
    {
      name: 'News',
      url: '/news',
      icon: 'icon-note'
    },
    {
      name: 'Events',
      url: '/events',
      icon: 'icon-calendar'
    },
    {
      name: 'Reports',
      icon: 'icon-list',
      open: false,
      children: [
        {
          name: 'Donations',
          url: '/reports/donations',
          icon: 'icon-wallet'
        },
        {
          name: 'Membership',
          url: '/reports/membership',
          icon: 'icon-organization'
        },
      ],
    },
  ]
}
